






























import { defineComponent, ref } from '@vue/composition-api';
import { SpecificPropsType } from '@/components/form/types';
import { ConfTable } from '@/components/table/table';
import { ConfTableProps } from '@/components/table/types';
import { getMPAppUserWhiteList } from '@api/plc';
import { whiteListColumns } from '../plc/white-list-columns';

export default defineComponent({
    components: {
        ConfTable,
    },
    props: ['mpAppId'] as unknown as SpecificPropsType<{
        mpAppId: string;
    }>,
    setup(props, { root }) {
        const visible = ref(false);
        const tableRef = ref<InstanceType<typeof ConfTable>>();
        const api: ConfTableProps['api'] = async (query) => {
            const res = await getMPAppUserWhiteList(
                root.$route.params.appId,
                props.mpAppId,
                {
                    pageSize: query.page.pageSize,
                    pageNum: query.page.currentPage,
                },
            );
            const { data } = res.data;
            return {
                data: data.uidInfoList,
                total: data.total,
            };
        };

        return {
            visible,
            tableRef,
            api,
            columns: whiteListColumns,
            fetch() {
                tableRef.value?.fetch();
            },
        };
    },
});
